<template>
  <div :class="['widget', {'border-error': error}]">

    <v-container>
      <div id="custom-header">
        <span
          id="title"
          class="subheading">
          Floor plans
        </span>
        <div style="display: flex; align-items: center;">
          <v-progress-circular
            v-if="posting"
            indeterminate/>
          <label v-else>
            <v-icon>add</v-icon>
            <input
              ref="abc"
              accept="image/png, image/jpeg"
              style="display: none;"
              type="file"
              @change="upload">
          </label>
        </div>
      </div>
      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>
      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <div
            v-for="(plan, index) in plans"
            :key="plan.name">
            <v-layout
              align-center
              justify-space-between>
              <v-flex grow>
                <span class="body-2">
                  {{ plan.name | nameToDate | formatLLL }}
                </span>
              </v-flex>
              <span style="display: flex;">
                <v-flex shrink>
                  <v-btn
                    v-if="plans[index].deleting === true"
                    class="ma-0"
                    disabled
                    icon>
                    <v-progress-circular
                      indeterminate
                      size="20"/>
                  </v-btn>
                  <v-btn
                    v-else
                    :disabled="plans[index].loading === true"
                    class="ma-0"
                    color="red--text text--lighten-3"
                    icon
                    @click="remove(index)">
                    <v-icon>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex shrink>
                  <v-btn
                    v-if="expand === index"
                    class="ma-0"
                    icon
                    @click="expand = -1">
                    <v-icon>expand_less</v-icon>
                  </v-btn>
                  <v-btn
                    v-else-if="plans[index].loading === true"
                    class="ma-0"
                    disabled
                    icon>
                    <v-progress-circular
                      indeterminate
                      size="20"/>
                  </v-btn>
                  <v-btn
                    v-else
                    class="ma-0"
                    icon
                    @click="getPlan(index)">
                    <v-icon>expand_more</v-icon>
                  </v-btn>
                </v-flex>
              </span>
            </v-layout>
            <v-layout>
              <v-expansion-panel
                v-if="expand === index"
                :value="expand === index ? 0 : -1"
                style="box-shadow: none;">
                <v-expansion-panel-content
                  style="background-color: initial;">
                  <img :src="plan.src">
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
            <v-divider/>
          </div>
        </v-container>
      </template>
    </v-container>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "",
  filters: {
    nameToDate (name) {
      const ts = parseInt(name.split("_")[1].split(".")[0], 10);
      return new Date(ts).toISOString();
    }
  },
  data () {
    return {
      error: false,
      expand: -1,
      plans: [],
      loading: false,
      posting: false
    };
  },
  created () {
    this.getAll();
  },
  methods: {
    ...mapActions(["notify"]),
    getPlan (index) {
      if (this.plans[index].src) {
        this.expand = index;
        return;
      }
      const { id } = this.plans[index];
      this.plans[index].loading = true;
      this.$http.
        get(
          `/api/sites/${this.$route.params.id}/floor_plans/${id}`,
          { responseType: "arraybuffer" }
        ).
        then((r) => {
          const b64 = Buffer.from(r.data).toString("base64");
          const src = `data:${r.headers["content-type"]};base64, ${b64}`;
          Object.assign(this.plans[index], { src }, { loading: false });
          this.expand = index;
        }).
        catch(() => this.error = true).
        finally(() => this.plans[index].loading = false);

    },
    getAll (config) {
      this.loading = true;
      this.$http.
        get(`/api/sites/${this.$route.params.id}/floor_plans`, config).
        then((r) => this.plans = Array.from(
          r.data.map((obj) =>
            Object.assign(obj, {
              deleting: false,
              loading: false,
              src: ""
            }))
        )).
        catch(() => this.error = true).
        finally(() => this.loading = false);
    },
    remove (index) {
      if (confirm("Remove this plan from Google Drive (unrecoverable)?")) {
        const { id } = this.plans[index];
        this.plans[index].deleting = true;
        this.$http.
          delete(`/api/sites/${this.$route.params.id}/floor_plans/${id}`).
          then(() => {
            this.expand = -1;
            this.getAll({ headers: { "Cache-Control": "no-cache" } });
          }).
          finally(() => this.plans[index].deleting = false);
      }
    },
    upload () {
      const [ file ] = this.$refs.abc.files;
      if (file.size > 5000000) {
        this.notify({ msg: "This file is too large (size > 5 MB)." });
      } else if (file.type !== "image/png" && file.type !== "image/jpeg") {
        this.notify({ msg: "This file type is not supported." });
      } else {
        this.posting = true;
        const reader = new FileReader();
        reader.onload = () =>
          this.$http.
            post(
              `/api/sites/${this.$route.params.id}/floor_plans`,
              reader.result,
              { headers: { "Content-Type": file.type } }
            ).
            then(() => this.
              getAll({ headers: { "Cache-Control": "no-cache" } })).
            finally(() => this.posting = false);
        reader.readAsArrayBuffer(file);
      }
    }
  }
};
</script>

<style scoped>
#custom-header {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  justify-content: space-between;
}
label {
  display: flex;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
}
label:hover {
  background-color: #494949;
  cursor: pointer;
}
label i {
  flex: auto;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Site/FloorPlan.vue